import {gsap} from "../../../libs/gsap/all.js";
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';
import {Point} from 'pixi.js';

// Constructor
export class GameTambour_Note extends PIXI.Container {

  constructor(type, hasLabel, game) {
    super();

    this.game = game;
    this.hasLabel = hasLabel;
    this.type = type;
    this.isCurrentNote = false;
    this.hasPassed = false;
    this.hitChecked = false;

    this.texts = {
      center: {
        en: "CENTER",
        fr: "CENTRE",
      },
      left: {
        en: "LEFT",
        fr: "GAUCHE",
      },
      right: {
        en: "RIGHT",
        fr: "DROITE",
      }
    }

    this.build();
  }

  build() {

    this.image = new PIXI.Sprite(this.game.assets[`${this.type}-note`]);
    this.addChild(this.image);

    if (this.hasLabel) {
      // Tag text style
      this.tagTextStyle = new PIXI.TextStyle({
        align: "center",
        fill: "#00156B",
        fontFamily: "Sketchnote Text",
        fontSize: 24,
        wordWrap: true,
        wordWrapWidth: 400
      });

      this.label = new PIXI.Container();
      const labelBg = new PIXI.Graphics().roundRect(0, 0, 180, 42, 42 / 2).fill(0xC6D9F4);
      this.label.addChild(labelBg);
      this.label.position.x = this.width / 2 - labelBg.width / 2;
      this.label.position.y = this.image.height + 20;

      this.tagTextEN = this.game.createInterfaceText(this.texts[this.type]["en"], {...this.tagTextStyle}, "en"); // use a copy of the baseButtonTextStyle so we can update them individually
      this.tagTextFR = this.game.createInterfaceText(this.texts[this.type]["fr"], {...this.tagTextStyle}, "fr"); // use a copy of the baseButtonTextStyle so we can update them individually
      this.tagTextEN.anchor.set(0.5); // center in box easier
      this.tagTextFR.anchor.set(0.5); // center in box easier
      this.tagTextEN.position.x = this.label.width / 2;
      this.tagTextFR.position.x = this.label.width / 2;
      this.tagTextEN.position.y = this.label.height / 2;
      this.tagTextFR.position.y = this.label.height / 2;

      this.label.addChild(this.tagTextEN);
      this.label.addChild(this.tagTextFR);

      this.addChild(this.label);
    }

    this.buildAnimations();
  }

  enable() {
    this.renderable = true;
  }

  disable() {
    this.renderable = false;
  }

  buildAnimations() {

    // this.bgArea.alpha = 0;

    // this.inAnimation = gsap.fromTo(this, {
    //     pixi: {
    //       scale: 0,
    //       alpha: 0,
    //     },
    //   }, {
    //     pixi: {
    //       scale: 1,
    //       alpha: 1,
    //     },
    //     ease: "power1.inOut",
    //     immediateRender: true,
    //     paused: true,
    //     duration: 1,
    //     onComplete: () => {
    //       this.enable();
    //       // this.bgArea.alpha = 1;
    //     }
    //   }
    // );
  }

  getCenterPosition() {
    return (-1 * this.image.toLocal(this.game.rightAreaContainer.position, null).x) + (this.image.width / 2);
  }

  isInHitZone() {
    const pos = this.getCenterPosition();
    const isIn = pos > this.game.hitZonePosRange.min && pos < this.game.hitZonePosRange.max;
    // this.alpha = isIn ? 1 : 0.5; // Usefull for debugging to see if note is in the zone or not
    return isIn;
  }

  hasPassedHitZone() {
    const pos = this.getCenterPosition();
    return pos <= 0;
  }

  animateIn() {
    if (this.inAnimation) {
      this.inAnimation.play();
    }
  }


  resetState(duration) {
    this.isCurrentNote = false;
    this.hasPassed = false;
    this.hitChecked = false;
  }

  // Reset the states so we can animate in again and start over
  reset() {
    if (this.inAnimation) {
      this.inAnimation.kill();
      this.inAnimation = null;
    }

    this.resetState(0);

    // Rebuild the animations
    this.buildAnimations();
  }


}
